import { Routes as GlobalRoutes } from "../constants/RouteConstants";
import Profile from "../pages/Profile/CompanyProfile/Profile";
import ProfileDetails from "../pages/Profile/ProfileDetails";
import Dashboard from "../pages/Dashboard/Dashboard";
import ServicesManagementTable from "../pages/Dashboard/Pages/Services/ServiceManagement";
import CustomerSupport from "../pages/Dashboard/Pages/CustomerSupport";
import MyProfile from "../pages/Dashboard/Pages/MyProfile/MyProfile";
import AddSevice from "../pages/Dashboard/Pages/Services/Service";
import ServiceManagementUpdate from "../pages/Dashboard/Pages/Services/ServiceEdit";
import SalonAvailability from "../pages/Dashboard/Pages/SalonAvailability/SalonAvailability";
import StaffMember from "../pages/Dashboard/Pages/Staff/StaffMember";
import StaffMemberDetails from "../pages/Dashboard/Pages/Staff/StaffMemberDetails";
import ServiceManagementView from "../pages/Dashboard/Pages/Services/ServiceManagementView";
import MyBookings from "../pages/MyBookings/MyBookings";
import MyBookingsDetails from "../pages/MyBookings/MyBookingsDetails";
import StaffMemberUpdate from "../pages/Dashboard/Pages/Staff/StaffMemberEdit";
import ChangePassword from "../pages/Auth/ChangePassword";
import OfflineBooking from "../pages/OfflineBooking/OfflineBooking";
import BillingManagement from "../pages/Billing/BillingManagement";
import StaffAvailability from "../pages/Dashboard/Pages/SalonAvailability/StaffAvailability";
import BillingManagementView from "../pages/Billing/BillingManagementView";
import SalesGrowth from "../pages/SalesGrowth/SalesGrowth";
import SubscriptionPlans from "../pages/Subscription/SubscriptionPlans";
import SubscriptionPurchase from "../pages/Subscription/SubscriptionPurchase";

export const privateRoutes = [

    {
        path: GlobalRoutes?.Profile,
        element: <Profile />
    },
    {
        path: GlobalRoutes?.ProfileDetail,
        element: <ProfileDetails />
    },
    /* Dashboard */

    {
        path: GlobalRoutes?.Dashboard,
        element: <Dashboard />
    },
    {
        path: GlobalRoutes?.ServiceManagement,
        element: <ServicesManagementTable />
    },
    {
        path: GlobalRoutes?.ServiceManagementView,
        element: <ServiceManagementView />,
    },
    {
        path: GlobalRoutes?.ContactSupport,
        element: <CustomerSupport />
    },
    {
        path: GlobalRoutes?.MyProfile,
        element: <MyProfile />
    },

    {
        path: GlobalRoutes?.AddService,
        element: <AddSevice />,
    },
    {
        path: GlobalRoutes?.ServiceUpdate,
        element: <ServiceManagementUpdate />,

    },
    {
        path: GlobalRoutes?.salonAvalibility,
        element: <SalonAvailability />,
    },
    {
        path: GlobalRoutes?.StaffMember,
        element: <StaffMember />,
    },
    {
        path: GlobalRoutes?.StaffMemberUpdate,
        element: <StaffMemberUpdate />,
    },
    {
        path: GlobalRoutes?.salonAvalibility,
        element: <SalonAvailability />,
    },
    {
        path: GlobalRoutes?.StaffMember,
        element: <StaffMember />,
    },
    {
        path: GlobalRoutes?.StaffMemberDetails,
        element: <StaffMemberDetails />,
    },
    {
        path: GlobalRoutes?.MyBookings,
        element: <MyBookings />,
    },
    {
        path: GlobalRoutes?.MyBookingsDetails,
        element: <MyBookingsDetails />,
    },
    {
        path: GlobalRoutes?.ChangePassword,
        element: <ChangePassword />,
    },
    {
        path: GlobalRoutes?.OfflineBooking,
        element: <OfflineBooking />,
    },

    {
        path: GlobalRoutes?.BillingManagement,
        element: <BillingManagement />,
    },
    {
        path: GlobalRoutes?.StaffAvailability,
        element: <StaffAvailability />,
    },
    {
        path: GlobalRoutes?.BillingManagementView,
        element: <BillingManagementView />,
    },
    {
        path: GlobalRoutes?.SalesGrowthManagement,
        element: <SalesGrowth />,
    },
    {
        path: GlobalRoutes?.SubscriptionPlans,
        element: <SubscriptionPlans />,
    },
    {
        path: GlobalRoutes?.SubscriptionPurchase,
        element: <SubscriptionPurchase />,
    },
    // {
    //     path: GlobalRoutes?.PrivacyPolicy,
    //     element: React.lazy(() => import("../pages/CmsPages/PrivacyPolicy")),
    // },

]

